// extracted by mini-css-extract-plugin
export default {"tabPanelContenedor":"tabPanel_tabPanelContenedor__6AR6d","boxContainer":"tabPanel_boxContainer__Mcmo3"};